<template>
<div class="app flex-row align-items-center login-dash">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-4 p-0">
        <div class="card-group mb-4">
          <div class="card login-left p-4">
            <div class="card-body">
              <h1 class="">{{$t('WELCOMEBACK')}}</h1>
              <p class="text-muted">{{$t('WELCOMETAGLINE')}}</p>

            </div>
          </div>
          <!--
            <div class="card text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <div class="card-body text-center">
                <div>
                  <h2>{{$t('SIGNUP')}}</h2>
                  <p>{{$t('SIGNUPINTRO')}}</p>
                  <button type="button" class="btn btn-primary active mt-3">{{$t('REGISTERNOW')}}</button>
                </div>
              </div>
            </div>
            -->
        </div>
      </div>
      <div class="col-md-5 p-0">
        <div class="card-group mb-4">
          <div class="card login-right p-4">
            <div class="card-body">
              <h1 class="">{{$t('LOGINTOYOURACCOUNT')}}</h1>
              <p class="text-muted mb-4">{{$t('LOGINTAGLINE')}}</p>
              <div class="input-group mb-3">
                <label class="input-group-addon login-label">{{$t('USERNAME')}}</label>
                <input type="text" v-model="username" v-on:keyup.13="login" class="form-control" v-bind:placeholder="$t('USERNAME')">
              </div>
              <div class="input-group mb-4">
                <label class="input-group-addon login-label">{{$t('PASSWORD')}}</label>
                <input type="password" v-model="password" v-on:keyup.13="login" class="form-control" v-bind:placeholder="$t('PASSWORD')">
              </div>
              <div class="row">
                <div class="col-12">
                  <p class="bg-danger" v-if="loginResponse.error && loginResponse.notice">{{loginResponse.notice}}</p>
                </div>

                <div class="col-8 text-left">
                  <a href="mailto:info@foursightsupplyco.com">
                    <button type="button" class="btn btn-link px-0">{{$t('HAVINGPROBLEMS')}}</button>
                  </a>
                </div>
                <div class="col-4 text-right">
                  <button type="button" v-on:click.prevent="login" class="btn btn-primary px-4">{{$t('SIGNIN')}}</button>
                </div>
              </div>
            </div>
          </div>
          <!--
            <div class="card text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <div class="card-body text-center">
                <div>
                  <h2>{{$t('SIGNUP')}}</h2>
                  <p>{{$t('SIGNUPINTRO')}}</p>
                  <button type="button" class="btn btn-primary active mt-3">{{$t('REGISTERNOW')}}</button>
                </div>
              </div>
            </div>
            -->
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import
{
  mapActions,
  mapGetters
}
from 'vuex'

export default
{
  name: 'Login',
  data: function()
  {
    return {
      username: '',
      password: ''
    }
  },
  methods:
  {
    ...mapActions(
    {
      actLogin: 'login'
    }),
    login: function(bvEvt)
    {
      bvEvt.preventDefault();
      this.actLogin(
      {
        username: this.username,
        password: this.password
      });
    }
  },
  computed:
  {
    ...mapGetters([
      'loginResponse'
    ])
  }
}
</script>
